import type { ScenarioId } from '@finsim/model';
import { useUnit } from 'effector-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ItemIcon } from '../../entities/project';
import {
  Menu,
  MenuContent,
  MenuItem,
  MenuLabel,
  MenuSeparator,
  MenuTrigger,
} from '../../shared/ui';
import { addItemRequested, TEMPLATE_MENU } from './model';

export interface AddItemMenuProps {
  scenarioId: ScenarioId;
  /** The trigger element (rendered with `asChild`). */
  children: ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

/** Template picker that adds a new item to a variant and opens it in the inspector. */
export function AddItemMenu({ scenarioId, children, open, onOpenChange }: AddItemMenuProps) {
  const { t } = useTranslation();
  const add = useUnit(addItemRequested);
  return (
    <Menu {...(open === undefined ? {} : { open })} {...(onOpenChange ? { onOpenChange } : {})}>
      <MenuTrigger asChild>{children}</MenuTrigger>
      <MenuContent align="start" className="min-w-56">
        {TEMPLATE_MENU.map(({ group, ids }, index) => (
          <div key={group}>
            {index > 0 && <MenuSeparator />}
            <MenuLabel>{t(`groups.${group}`)}</MenuLabel>
            {ids.map((templateId) => {
              return (
                <MenuItem
                  key={templateId}
                  icon={<ItemIcon item={{ template: templateId, type: 'flow' }} />}
                  onSelect={() => {
                    add({
                      scenarioId,
                      templateId,
                      name: t(`templates.${templateId}`),
                      contributionsName: t('tax.contributions'),
                    });
                  }}
                >
                  {t(`templates.${templateId}`)}
                </MenuItem>
              );
            })}
          </div>
        ))}
      </MenuContent>
    </Menu>
  );
}
